module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "rounded-lg",
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', [_vm._v("\n    Rechnungen " + _vm._s(_vm.kasse) + "\n    "), _c('v-spacer'), _vm._v(" "), _c('v-chip', {
    attrs: {
      "label": "",
      "small": ""
    }
  }, [_vm._v(_vm._s(_vm.status))])], 1), _vm._v(" "), _c('v-simple-table', {
    staticClass: "rounded-lg",
    attrs: {
      "dense": "",
      "fixed-header": "",
      "no-data-text": "Keine Striche vorhanden"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Empfänger")]), _vm._v(" "), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Summe")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.rechnungen), function(item) {
    return _c('tr', {
      key: item.name,
      on: {
        "dblclick": function($event) {
          (_vm.showRechnung = true) && (_vm.rechnungid = item.id)
        }
      }
    }, [_c('td', [_vm._v(_vm._s(_vm.$filters.user(item.bbrID, _vm.bbrbbr)))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm._f("money")(item.summe)))])])
  }), _vm._v(" "), (_vm.anzahlRechnungen > 10) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.anzahlRechnungen - 10) + " weitere Rechnungen")])]) : _vm._e()], 2)]), _vm._v(" "), (_vm.rechnungen.length === 0) ? _c('div', {
    staticClass: "text-center caption pa-3"
  }, [_vm._v("Keine Rechnungen vorhanden")]) : _vm._e(), _vm._v(" "), _c('dialogRechnung', {
    attrs: {
      "visible": _vm.showRechnung,
      "rechnungid": _vm.rechnungid
    },
    on: {
      "update:visible": function($event) {
        _vm.showRechnung = $event
      },
      "close": function($event) {
        _vm.showRechnung = false
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f44eb97a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/module_klein/rechnungenStatus.vue
// module id = 821
// module chunks = 15